import { render } from "./IconTrash.vue?vue&type=template&id=782e99e5"
const script = {}
script.render = render

export default script